import { environment } from "src/environments/environment"

export class urls {
    static SERVER_URL = environment.baseUrl
    static REPORT_SERVER_URL = environment.reportServerUrl
    static BASE_REPORT_SERVER_URL = environment.reportServerUrl + 'api/'
    static BASE_URL = environment.baseUrl + 'api/'
    static FARMOUT_BASE_URL = environment.FARMOUT_AUTH_URL + 'api/v1/'
    static BROKER_PANEL_URL = environment.BROKER_PANEL_URL + 'api/v1/'
    static OUT_BOUNDS_BASE_URL = environment.OUT_BOUNDS_BASE_URL
    static OUTBOUND_CONVERSATION_BASE_URL = environment.OUTBOUND_CONVERSATION_BASE_URL + 'api/'
    static PLANNER_BASE_URL = environment.PLANNER_BASE_URL
    static PROVIDER_URL = environment.PROVIDER_URL
    static IS_PROD = environment.production

    static DRIVERS_GRIEVANCE = 'grievances'

    static SIGNIN_URL = 'auth/signin'
    static FORGOT_URL = 'auth/forgot'
    static RESET_URL = 'auth/reset'
    static PROFILE_URL = 'users/me'
    static STAFF_URL = 'staffs'
    static STAFF_CREATE_URL = 'staffs/create'
    static STAFF_TIMELINES_URL = 'stafftimelines'
    static STAFF_CURRENT_TIMELINES = 'stafftimelines/current'
    static STAFF_TIMELINES_DASHBOARD_URL = 'stafftimelines/dashboard'
    static STAFF_SHIFTS = 'staffshifts'
    static CHANGE_PASSWORD_URL = 'users/password'
    static CHANGE_PROFILE_IMAGE = 'users/picture'
    static DISPATCH_CENTER_HISTOR_URL = 'dispatches/company'
    static NOTIFICATIONS_URL = 'notifications'
    static DRIVERS_URL = 'drivers/companies'
    static ADD_DRIVER_URL = 'drivers'
    static DRIVER_RESET_PASSWORD_URL = 'drivers/resetpassword'
    static DRIVER_FORCE_LOGOUT_URL = 'drivers/forcelogout'
    static COPORATE_USER_LIST_URL = 'cooperates'
    static COPORATE_ADD_USER_URL = ''
    static FLEET_LIST_URL = 'fleets?'
    static CREDENTIALED_FLEET_LIST_URL = 'fleets/credentiallist'
    static ADD_FLEET_URL = 'fleets'
    static GET_CAUTIONS_URL = 'cautions'


    static DRIVER_DISTRIBUTION_URL = 'distributions'
    static INVITES_LIST_URL = 'sms'
    static DRIVERS_SMS_URL = 'driveralerts'
    static QUERIES_URL = 'queries'
    static ADD_VEHICLE_EXPENSE_SERVICE_URL = 'maintenances/services'
    static DRIVER_EXPENSE_URL = 'maintenances/drivers?driver='
    static VEHICLE_EXPENSE_URL = 'maintenances?fleet='
    static MAINTENANCE_STATS_URL = 'maintenances/stats'
    static GET_PLANNER_URL = 'planner/range?startDate='
    static GET_NEMT_PRO_TIPS_URL = 'protips'


    static GET_UNASSIGN_TRIPS_URL = 'assigns'
    static TRIP_PAYMENTS = 'trippayments/ref'
    static GET_ADJUSTED_TRIPS_URL = 'adjusttrips'

    static GET_CMS_1500_REPORT = 'assigns/cms1500'

    static GET_OUTSTANDING_TRIPS_URL = 'assigns/outstanding'
    static GET_BULKWRITE_TRIPS_URL = 'assigns/lines'
    static ASSIGN_MULTIPLE_TRIPS_URL = 'assigns/selectedtrips'
    static GET_ASSIGNED_TRIPS_LIST = 'assigns/corporate'
    static VERIFIED_CANCEL_TRIP_URL = 'assigns/verifiedcancelled'
    static GENRATE_TRIP_SIGNATURE_URL = 'assigns/canvasSignature'
    static UPDATE_ALL_TRIPS_SIGNATURE_URL = 'assigns/autosignature'
    static BANKED_TRIP_URL = 'assigns/banked'
    static SINGLE_TRIP = 'assigns/singletrip'
    static MARK_COMPLETED_TRIP = "assigns/markcompleted"
    static GENERATE_TRIPS_REPORT = "assigns/assignedtripsexcel"
    static SEND_CONFIRMATION_TEXT_URL = "assigns/tripconfirmation"
    static AUTO_TRIP_ADJUSTMENT_URL = "assigns/autotripadjustment"
    static TRIP_ODOMETER_ADJUST_URL = "assigns/adjustodometer"
    static CORPORATE_USER_REPORT_URL = "assigns/corporate/report"

    static GET_CORPORATE_USER_LIST = 'cooperates'
    static GET_CREDENTIALED_CORPORATE_USER_LIST = 'cooperates/credentiallist'
    static GET_CORPORATE_EXCEL_URL = 'cooperates/corporatexcel'
    static CREATE_NEW_TRIP_URL = 'assigns'
    static NEMT_STATISTICS_URL = 'kpis/jobs/stats'
    static NEMT_REPORTS_URL = 'kpis'
    static ADMIN_NEMT_REPORTS_URL = 'companies'
    static ADMIN_NEMT_REPORTS_BY_DATE_URL = 'adminkpis'
    static ADMIN_COMPANY_REPORTS_URL = 'adminkpis/adminreport'
    static NEMT_STATISTICS_DETAIL_URL = 'kpis/jobs/statsByRange'
    static NEMT_STATISTICS_DETAIL_BY_MEMBER_ID_URL = 'kpis/jobs/statsdetails'
    static GET_DYNAMIC_FARE_LIST = 'dynamicfares'

    static GET_REPORTS_URL = 'reports/company/'

    static GET_TRIP_DETAILS_URL = 'dispatches'
    static GET_COMPLETED_TRIP_DETAIL = 'assigns/jobbyid?assignId='
    static DRIVER_TRIP_FARE_URL = 'dispatches/driverfare'
    static DRIVER_TRIP_FARE_URL_NEW = 'jobs/updatefare'

    static GET_ADJUSTMENT_DETAIL_URL = 'jobs/adjustment/'
    static GET_ADJUSTMENT_DETAIL_TRIPSLOGS_URL = 'adjusttrips/'

    static GET_NEARBY_DRIVER_URL = 'drivers/nearby'
    static FARMOUT_DRIVERS_URL = 'drivers/farmout'
    static TRIPS_FOR_ASSIGN_DASHBOARD_URL = 'assigns/dashboard'

    static DRIVER_GENERATE_QR_URL = 'drivers/generateqr'
    static DRIVER_SIGNATURE_URL = 'drivers/signature'
    static DRIVER_CALCULATE_INVOICE_URL = 'driverinvoices'
    static DRIVER_TIMELINES_URL = 'timelines'
    static DRIVER_CURRENT_TIMELINES = 'timelines/current'
    static DRIVER_AMENDMENTS_URL = 'ammendments'
    static DRIVER_TIMELINES_DASHBOARD_URL = 'timelines/dashboard'
    static NEMT_STAT_REPORT_PDF_URL = 'kpis/kpistatsreport'
    static NEMT_STAT_TRIP_REPORT_XLS_URL = 'kpis/kpitripsreport'
    static NEMT_BUSSINESS_REPORT_PDF_URL = 'kpis/businesskpi'
    static NEMT_GMT_KPI_REPORT_PDF_URL = 'kpis/gmt'
    static NEMT_DRIVER_KPI_REPORT_PDF_URL = 'kpis/driverkpi'
    static NEMT_BROKER_REPORT_PDF_URL = 'kpis/brokerkpi'
    static NEMT_CORPORATE_REPORT_PDF_URL = 'kpis/corporatekpi'
    static NEMT_CORPORATE_TRIP_REPORT_PDF_URL = 'kpis/corporateTrips'
    static NEMT_DRIVER_REPORT_PDF_URL = 'kpis/driverkpi'
    static SINGLE_FLEET_QR_URL = 'fleets/generateqr/'
    static ALL_FLEET_QR_URL = 'fleets/fleetqr'

    static GET_DRIVER_PDF_REPORT_URL = 'reports/driver/'
    static GET_PAYMENT_PDF_REPORT_URL = 'reports/admin/'
    static GET_ADMIN_EARNING_DETAILS_URL = 'reports/admin'
    static GET_BROKER_RATE_URL = 'assigns/jobbyid?assignId='
    static GET_COMPLETED_TRIPS_URL = 'assigns/jobbyid'
    static SCRAP_TRIPS_URL = 'assigns/scrap'
    static AI_EXTRACT_TRIP_URL = 'assigns/ai-extract'
    static DRIVER_BREAKDOWN_URL = 'kpis/bussiness'
    static GET_SWEEP_TRIPS_LIST_URL = 'assigns/parselist'
    static GET_UNPARSED_TRIPS_URL = 'assigns/unparsedtrips'
    static SEND_TRIP_LIST_EMAIL_URL = 'assigns/files/'

    static ACCIDENT_REPORT_URL = 'accidentalreports'
    static GENERATE_ACCIDENTAL_REPORT = 'generateaccidentalreports'
    static FACILITY_TRIPS_URL = 'facilitytrips'
    static FACILITY_TRIPS_COUNTER_URL = 'facilitytrips/dashboard'

    static MEMBER_URL = 'members'
    static SIGNATURE_URL = 'clients/signature'
    static CLIENT_URL = 'clients'
    static EXPENSE_URL = 'expenses'
    static CLIENTS_LOCK = 'clientlockids'

    static TRACKING_SMS_URL = 'trackingsms'
    static GET_CTC_TRIPS = 'brokersettings/ctc'
    static GET_RIDECAFE_TRIPS = 'brokersettings/ridecafe'
    static GET_CTC_CLAIMED_TRIPS = 'ctcclaimedtrips'
    static GET_MTM_TRIPS = 'brokersettings/mtm'
    static GET_KAISER_TRIPS = 'brokersettings/kaiser'
    static GET_MEDIDRIVE_TRIPS = 'brokersettings/medidrive'
    static BROKER_SETTING_URL = 'brokersettings'
    static GET_COMPANIES_LIST = 'companies'
    static GET_QUARTER_LIST = 'quarterpanels'
    static GET_INVOICE_LIST = 'companies'
    static GET_COMPANY_DATA_URL = 'providerinvoicesettings'
    static GET_TRIP_ASSISTANCE_LIST = 'tripassistances'
    // ---CORPORATE ADDON---
    static GETCORPORATEADDON = 'addonservices'
    static GET_CORPORATE_ADDON_SERVICES = 'addonservices/corporate?isdefault=true'
    static ADD_VEHICLE_INSPECTIONS = 'vehicleinspections'
    static DAILY_VEHICLE_INSPECTIONS_URL = 'vehciledailyinspections'
    // static GENERATE_VEHICLE_INSPECTIONS_SIGNATURE_URL = '/api/vehicleinspections'
    static GET_NEMT_CODES = 'nemtcodes'
    static CMS_1500_CODES = 'cms1500s'
    static SEND_DRIVER_MANIFEST = 'assigns/senddrivermanifest'
    static GET_KPI_SCORE = 'kpis/score'
    static GET_MANIFEST_TRIPS = 'assigns/getmanifesttrips'
    static GET_TRIP_PURPOSES = 'purposes'
    static LEVEL_OF_SERVICE = 'vehicles'
    static TP_LEVEL_OF_SERVICE = 'tpvehicles'
    static GET_COMPANY_TOKEN = 'getCompanyToken'
    static SERVICE_AREAS = 'serviceareas'
    static DOCUMENTS = 'documents'
    static LEVEL_OF_SERVICE_URL = 'levelofservices'
    static SPACE_TYPE_URL = 'spacetypes'
    static EQUIPMENT_URL = 'equipments'
    static PRIMARY_DIAGNOSE_URL = 'nemtcodes'
    static MODIFIER_CODES_URL = 'modifiers'
    static CORPORATE_BROKERS = 'cooperates/brokers'
    static SPACE_TYPE_MAPPERS = 'spacetypemappers'
    static CALCULATE_ESTIMATE_FARE = 'assigns/tempestimatedfare'
    static GET_SMS_DASHBOARD_DATA = 'smsdashboards'
    static DRIVER_BREAK = 'assigns/addupdatebreak'
    static TRIP_ACTIVITY_LOG = 'assigns/activitylogs'
    static PLANNER_MAPPER = 'plannermappers'
    static PLANNER_DRIVER_MAPPER = 'plannerdrivermappers'
    static FARE_FORMULA = 'jobs/formula'
    static EDIREPORTS = 'edireports'
    static OUTBOUND_MESSAGES = 'assigns/twillioreport'
    static GET_ASSIST_LIST = 'assists'
    static GET_BUCKATTENDEE_LIST = 'bucksattendee'
    static GET_BUCKATTENDEE_DASHBOARD = 'bucksattendee/dashboard'
    static GET_BROADCASTS_LIST = 'broadcasts'
    static GET_AGENT_TRIPS = 'articles'

    static MONEY_FOR_BUCKS = 'bucks'
    static MONEY_FOR_BUCKS_DASHBOARD = 'dashboard'
    static GET_HOLIDAYS_LIST = 'holidays'
    static CHECK_LIST_SPACE_TYPES = 'checklistspacetypes'
    static TRIP_CHECK_LIST = 'tripchecklist'
    static PLANNER_TEMPLATE = 'plannertemplates'
    static GET_RECEIPTS_STATS = 'receipts/dashboard2'
    static GET_RECEIPTS = 'receipts/company'
    static BILLED_TO_MODIVCARE_URL = 'assigns/billedtomodivcare'
    static RESEND_TO_CTC = 'assigns/resendtoctc'
    static TRAIL = '/trail'
    static DRIVER_TRAIL = '/drivertrail'
    static DRIVER_SHIFTS = 'drivershifts'
    static BULK_TRIP_CONFIRMATION = 'assigns/bulktripconfirmation'
    static PUSH_TO_TALK = 'pushtotalk'
    static ALL_PUSH_TO_TALK_MESSAGES = 'allpushtotalkmessages'
    static PUSH_TO_TALK_MESSAGES = 'pushtotalkmessages'
    static OUTBOUND_CONVERSATION = 'records/trip/'
    static ALC_DRIVER_URL = 'alcdrivers'
    static GET_CTS_TRIPS = 'brokersettings/cts'
    static ROUTE_STANDING_ORDER_URL = 'busroutes'
    static ROUTE_URL = 'bustrips'
    static TUTORIALS = 'academy/external'

    static BUSINESS_REPORTS_OVERVIEW_URL = 'business-reports/overview'
    static BUSINESS_REPORTS_BREAKDOWN_URL = 'business-reports/breakdown'
    static BUSINESS_REPORTS_DRIVER_DIGEST_URL = 'business-reports/driver-digest'
    static BUSINESS_REPORTS_TIMELINESS_URL = 'business-reports/timeliness'
    static BUSINESS_REPORTS_TRIPS_URL = 'business-reports/trips'
    static BUSINESS_REPORTS_REVENUE_URL = 'business-reports/revenue'
    static STAFF_LOGINS_URL = 'stafflogins'
    static ACCOUNT_LINKS_URL = 'accountlinks'
    static ACCOUNT_LINKS_SIGNIN_URL = 'accountlinks/signin'
    static GET_FARMOUT_SAVINGS = 'farmoutsavings'
    static GET_FARMOUT_SAVINGS_STATS = 'farmoutsavings/stats'
}
